module.exports = {
    'primer.client-token.store': 'payments/client-token',
};
